"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlockedIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class UnlockedIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 40 40", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M9,18 L30,18 L30,33 L9,33 L9,18 Z M20.25,23.79 C20.6955,23.5305 21,23.052 21,22.5 C21,21.672 20.3265,21 19.5,21 C18.672,21 18,21.672 18,22.5 C18,23.052 18.303,23.5305 18.75,23.79 L18.75,27.75 C18.75,28.1625 19.086,28.5 19.5,28.5 C19.9125,28.5 20.25,28.1625 20.25,27.75 L20.25,23.79 Z" }),
                    React.createElement("path", { d: "M21.4016182,17.2781158 L21.4016182,12.7783614 C21.4016182,10.29308 19.3868996,8.27836139 16.9016182,8.27836139 C14.4163369,8.27836139 12.4016182,10.29308 12.4016182,12.7783614 L12.4016182,17.2781158 L9.40137265,17.2781158 L9.40137265,12.2781158 C9.40137265,8.41212257 12.5353794,5.27811582 16.4013727,5.27811582 L17.4013727,5.27811582 C21.2673659,5.27811582 24.4013727,8.41212257 24.4013727,12.2781158 L24.4013727,17.2781158 L21.4016182,17.2781158 Z", transform: "translate(16.901373, 11.278116) rotate(-40.000000) translate(-16.901373, -11.278116) " })))));
    }
}
exports.UnlockedIcon = UnlockedIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/unlocked.tsx
// module id = 2171
// module chunks = 0 1 2